(ns renolit-roofing-service.layout.form.form-item.radio-button
  (:require [goog.object :as g]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.localization :refer [t]]))

(defn- on-change-event-handler
  [opts]
  (fn [e]
    (let [new-value (g/getValueByKeys e "target" "checked")]
      (form.form-item/on-change-event-handler opts :on-change new-value))))

(defmethod form.form-item/form-item-component :radio-button
  [{:keys [context path]}]
  (let [component-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])]
    (fn [{:keys [state path group-name css-class-prefix
                 label label-transl-kw disabled? full-line?] :as opts}]
      [:div.form-item.form-item--radio-button
       {:class [(when disabled? "form-item--disabled")
                (when css-class-prefix css-class-prefix)
                (when full-line? "form-item--full-line")
                (when (seq @form-errors) "form-item--error")]}
       [:input.form-item__radio-button
        (cond-> {:id component-id
                 :type "radio"
                 :name group-name
                 :disabled (boolean disabled?)
                 :checked (boolean (when state (get-in @state path)))
                 :on-change (on-change-event-handler opts)
                 :class []}
          css-class-prefix
          (update :class conj (str css-class-prefix "__radio-button"))

          (seq @form-errors)
          (update :class conj "form-item__radio-button--error"))]
       (when (or label label-transl-kw)
         [:label.form-item__label
          (cond-> {:for component-id}
            css-class-prefix
            (assoc :class (str css-class-prefix "__label"))

            (seq @form-errors)
            (assoc :title (form.error/form-error->msg (first @form-errors))))
          (or label (t [label-transl-kw]))])
       (when (seq @form-errors)
         [form.error/form-item-errors @form-errors])])))
